var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "viq-followups" }, [
    !_vm.hideHeader
      ? _c(
          "div",
          { staticClass: "viq-followups__header" },
          [
            _c("span", [_vm._v("Suggested follow-ups")]),
            _vm._v(" "),
            _c(
              "el-tooltip",
              {
                attrs: { effect: "dark", placement: "top", "open-delay": 300 },
              },
              [
                _c("div", { attrs: { slot: "content" }, slot: "content" }, [
                  _vm._v("Questions generated from the context"),
                  _c("br"),
                  _vm._v("of your previous question."),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "viq-followups__help-icon" }, [
                  _vm._v("?"),
                ]),
              ]
            ),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "viq-followups__chips" },
      _vm._l(_vm.suggestions, function (suggestion, i) {
        return _c(
          "button",
          {
            key: i,
            staticClass: "viq-followups__chip",
            on: {
              click: function ($event) {
                return _vm.askFollowUp(suggestion)
              },
            },
          },
          [
            _vm._v(
              "\n      " +
                _vm._s(
                  typeof suggestion === "string" ? suggestion : suggestion.text
                ) +
                "\n    "
            ),
          ]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }